import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import styles from './useStickyTopHeaderClassName.scss';

const siteStyle: Partial<Record<Sites, string>> = {
  [Sites.DEN]: 'Dk',
  [Sites.SWE]: 'Se',
  [Sites.FRA]: 'Fr',
  [Sites.POR]: 'Pt',
  [Sites.US_NJ]: 'Us',
  [Sites.USMI]: 'Usmi',
  [Sites.US_PA]: 'Uspa'
};

const useStickyTopHeaderClassName = (
  variant?: 'header' | 'sports' | 'casino'
): { styles: string; isStickyHeader: boolean } => {
  const site = useSelector(select.cms.getSiteId);
  const isSiteUs = useSelector(select.cms.isSiteUS);
  const isDownloadBannerVisible = useSelector(select.notification.showDownloadBanner);
  const isCasinoBrand = useSelector(select.cms.getBrandId) === BrandTypes.STARS_CASINO;
  const isUSCasinoBrand = isCasinoBrand && isSiteUs;
  const isStickyHeader =
    [Sites.SWE, Sites.DEN, Sites.FRA, Sites.POR].includes(site) || isUSCasinoBrand;

  useEffect(() => {
    const withDownloadBanner = () => {
      const [, navTopHeaderPoker] = document.querySelectorAll(
        '#top-nav-container'
      ) as NodeListOf<HTMLElement>;

      if (!isStickyHeader && isSiteUs && navTopHeaderPoker) {
        navTopHeaderPoker.style.top = '0';
        return;
      }

      if (!isStickyHeader) {
        return;
      }

      const appDownloadBanner = document.getElementById('app-download-banner');
      const stickyTopHeader = document.getElementById('sticky-top-container');
      const navStickyTopHeader = document.getElementById('top-nav-container');
      const subNavStickyTopHeader = document.getElementById('sub-nav-container');

      if (!isDownloadBannerVisible && stickyTopHeader) {
        stickyTopHeader.style.top = '0';
      }

      if (appDownloadBanner && stickyTopHeader) {
        const { bottom } = appDownloadBanner.getBoundingClientRect();
        if (bottom > 0) {
          stickyTopHeader.style.top = `${bottom}px`;
        } else {
          stickyTopHeader.style.top = '0';
        }
      }
      if (isCasinoBrand && stickyTopHeader && navStickyTopHeader && subNavStickyTopHeader) {
        navStickyTopHeader.style.top = `${stickyTopHeader.getBoundingClientRect().bottom}px`;
        subNavStickyTopHeader.style.top =
          window.getComputedStyle(subNavStickyTopHeader).position === 'sticky'
            ? `${navStickyTopHeader.getBoundingClientRect().bottom}px`
            : '0px';
      } else if (navStickyTopHeader) {
        navStickyTopHeader.style.top = '0';
      }
    };

    withDownloadBanner();
    window.addEventListener('scroll', withDownloadBanner);
    return () => window.removeEventListener('scroll', withDownloadBanner);
  }, [isDownloadBannerVisible, isStickyHeader, isCasinoBrand, isSiteUs]);

  if (!isStickyHeader || !variant) {
    return { styles: '', isStickyHeader };
  }

  return {
    styles: styles[`${variant}${siteStyle[site]}TopSticky` as keyof typeof styles],
    isStickyHeader
  };
};

export default useStickyTopHeaderClassName;
